import React from 'react';
import {UsersActionsLoadingDialog} from './UsersActionsLoadingDialog';
import {UsersActionsProvider} from '../context/UsersActionsContext';
import {UsersActionsCard} from './UsersActionsCard';

export function UsersActionsPage() {

  return (
    <UsersActionsProvider>
      <UsersActionsLoadingDialog />
      <UsersActionsCard />
    </UsersActionsProvider>
  );
}
